// Utilitaires d'authentification pour remplacer les fonctions GraphQL
import { jwtDecode } from 'jwt-decode'
import dexieService from '../services/dexieService'

export const fetchToken = async () => {
  return await dexieService.getAuthToken()
}

export const setToken = async (token) => {
  await dexieService.setAuthToken(token)
}

export const removeToken = async () => {
  await dexieService.removeAuthToken()
}

// Version synchrone pour la compatibilité avec le code existant
export const fetchTokenSync = () => {
  // Cette fonction est dépréciée, utiliser fetchToken() à la place
  console.warn('fetchTokenSync est déprécié, utiliser fetchToken() à la place')
  return null
}

export const isTokenValid = (token) => {
  if (!token) return false
  
  try {
    const decoded = jwtDecode(token)
    const currentTime = Date.now() / 1000
    return decoded.exp > currentTime
  } catch (error) {
    return false
  }
}

export const getUserFromToken = (token) => {
  if (!token) return null
  
  try {
    return jwtDecode(token)
  } catch (error) {
    return null
  }
}

export const isAuthenticated = async () => {
  const token = await fetchToken()
  return token && isTokenValid(token)
}
